import { PlanTrailActionContext } from "./types";

export const undoRedoActions = {
  async undo({ state, commit, dispatch }: PlanTrailActionContext) {
    // Try command-pattern undo first
    if (state.undoManager.canUndo) {
      state.undoManager.undo({ state });
      await dispatch('addAllRoutesToMap');
      return;
    }

    // Fall back to legacy snapshot-based undo
    if (state.activeRouteKey && state.routes[state.activeRouteKey]) {
      const activeRoute = state.routes[state.activeRouteKey];
      if (activeRoute.undoMarkers.length > 0) {
        await commit('updateRedo');

        const lastUndoMarkers = activeRoute.undoMarkers[activeRoute.undoMarkers.length - 1];
        const lastUndoLineStrings = activeRoute.undoLineStrings[activeRoute.undoLineStrings.length - 1];

        activeRoute.markers = JSON.parse(JSON.stringify(lastUndoMarkers));
        activeRoute.lineStrings = JSON.parse(JSON.stringify(lastUndoLineStrings));
        activeRoute.updated_at = new Date();

        state.markers = [...activeRoute.markers];
        state.lineStrings = [...activeRoute.lineStrings];

        await commit('popUndo');
        await dispatch('addAllRoutesToMap');
      }
    }
  },

  async redo({ state, commit, dispatch }: PlanTrailActionContext) {
    // Try command-pattern redo first
    if (state.undoManager.canRedo) {
      state.undoManager.redo({ state });
      await dispatch('addAllRoutesToMap');
      return;
    }

    // Fall back to legacy snapshot-based redo
    if (state.activeRouteKey && state.routes[state.activeRouteKey]) {
      const activeRoute = state.routes[state.activeRouteKey];
      if (activeRoute.redoMarkers.length > 0) {
        await commit('updateUndo');

        const lastRedoMarkers = activeRoute.redoMarkers[activeRoute.redoMarkers.length - 1];
        const lastRedoLineStrings = activeRoute.redoLineStrings[activeRoute.redoLineStrings.length - 1];

        activeRoute.markers = JSON.parse(JSON.stringify(lastRedoMarkers));
        activeRoute.lineStrings = JSON.parse(JSON.stringify(lastRedoLineStrings));
        activeRoute.updated_at = new Date();

        state.markers = [...activeRoute.markers];
        state.lineStrings = [...activeRoute.lineStrings];

        await commit('popRedo');
        await dispatch('addAllRoutesToMap');
      }
    }
  }
};
